export const GROUP_PIPELINE_STAGE = 'pipeline_stage';
export const GROUP_DATE_CREATED = 'date_created';
export const FILTER_HAS_PIPELINE_STAGE = 'has_pipeline_stage';
export const FILTER_PIPELINE_STAGE_NAME_IS = 'pipeline_stage_name_is';
export const FILTER_PIPELINE_STAGE_NAME_IS_NOT = 'pipeline_stage_name_is_not';
export const FILTER_PIPELINE_STAGE_NAME_IN = 'pipeline_stage_name_in';
export const FILTER_PIPELINE_STAGE_NAME_NOT_IN = 'pipeline_stage_name_not_in';
export const FILTER_DATE_CREATED_IS = 'date_created_is';
export const FILTER_DATE_CREATED_IS_NOT = 'date_created_is_not';
export const FILTER_DATE_CREATED_AFTER = 'date_created_after';
export const FILTER_DATE_CREATED_BEFORE = 'date_created_before';
export const FILTER_DATE_CREATED_BETWEEN = 'date_created_between';

export const messageByFilter = {
  [FILTER_HAS_PIPELINE_STAGE]: (value) => `${value ? 'has' : 'doesnt have'} **pipeline stage**`,
  [FILTER_PIPELINE_STAGE_NAME_IS]: (value) => `**pipeline stage** is **${value}**`,
  [FILTER_PIPELINE_STAGE_NAME_IS_NOT]: (value) => `**pipeline stage** is not **${value}**`,
  [FILTER_PIPELINE_STAGE_NAME_IN]: (value) =>
    `**pipeline stage** is one of **${value.join(', ')}**`,
  [FILTER_PIPELINE_STAGE_NAME_NOT_IN]: (value) =>
    `**pipeline stage** is not one of **${value.join(', ')}**`,
  [FILTER_DATE_CREATED_IS]: (value) => `**date created** is **${value}**`,
  [FILTER_DATE_CREATED_IS_NOT]: (value) => `**date created** is not **${value}**`,
  [FILTER_DATE_CREATED_AFTER]: (value) => `**date created** is after **${value}**`,
  [FILTER_DATE_CREATED_BEFORE]: (value) => `**date created** is before **${value}**`,
  [FILTER_DATE_CREATED_BETWEEN]: (value) =>
    `**date created** is between **${value[0] || 'since'}** and **${value[1] || 'until'}**`,
};

export const filtersByGroup = {
  [GROUP_PIPELINE_STAGE]: [
    FILTER_HAS_PIPELINE_STAGE,
    FILTER_PIPELINE_STAGE_NAME_IS,
    FILTER_PIPELINE_STAGE_NAME_IS_NOT,
    FILTER_PIPELINE_STAGE_NAME_IN,
    FILTER_PIPELINE_STAGE_NAME_NOT_IN,
  ],
  [GROUP_DATE_CREATED]: [
    FILTER_DATE_CREATED_IS,
    FILTER_DATE_CREATED_IS_NOT,
    FILTER_DATE_CREATED_AFTER,
    FILTER_DATE_CREATED_BEFORE,
    FILTER_DATE_CREATED_BETWEEN,
  ],
};
